import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Button } from '@components/button';
interface SearchToggleButtonProps {
  isListActive: boolean;
  onToggle: () => void;
}
export const SearchToggleButton: React.FC<SearchToggleButtonProps> = t0 => {
  const $ = _c(5);
  const {
    isListActive,
    onToggle
  } = t0;
  const t1 = isListActive ? "Show map view" : "Show list view";
  const t2 = `@search/${isListActive ? "HideList" : "ShowList"}-btn`;
  const t3 = isListActive ? "Show Map" : "Show List";
  let t4;
  if ($[0] !== onToggle || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <div className="bg-white block fixed right-1/2 bottom-0 -translate-y-8 translate-x-1/2 shadow-md lg:hidden z-50 rounded-full"><Button onClick={onToggle} variant="outlined" color="gray" size="sm" aria-label={t1} data-testid={t2}>{t3}</Button></div>;
    $[0] = onToggle;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};